module.exports = __webpack_public_path__ + "static/img/section5_01.c0ce170.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/section5_01.png
// module id = JKQK
// module chunks = 1